export const env = {
  // shown in the top bar so nobody edits the wrong environment
  environment: import.meta.env.MODE === 'production' ? 'Production' : 'Development',
  apiOrigin: import.meta.env.VITE_API_ORIGIN as string,
  firebase: {
    apiKey: import.meta.env.VITE_FIREBASE_API_KEY as string | undefined,
    authDomain: import.meta.env.VITE_FIREBASE_AUTH_DOMAIN as string | undefined,
    projectId: import.meta.env.VITE_FIREBASE_PROJECT_ID as string | undefined,
    appId: import.meta.env.VITE_FIREBASE_APP_ID as string | undefined,
  },
};
